export { BASE_URL } from "@sens/core/domain/url"
// client-side
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_IS_PRODUCTION === "true"
